import styled from 'styled-components';

export const P = styled.p`
    font-family: ${props => props.theme.baseFont};
    color: ${props => props.theme.paragraphColor};
    font-size: 1em;
    padding: 0;
`

export default P;